import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'compile',
    property: 'data-compile',
    targetSelector: 'self',
    visible: 'field-hide-all',
    default_value: 'false',
  },
  {
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-widget',
    targetSelector: '.module',
    name: 'widget',
    options: [
      {
        key: 'carousel',
        value: 'Carousel',
      },
      {
        key: 'badges',
        value: 'Badges',
      },
      {
        key: 'embeddedWidget',
        value: 'Embedded Widget',
      },
      {
        key: 'dedicatedPage',
        value: 'Dedicated Page',
      },
    ],
    links:
      'mode,type,count,showBottomLine,autoplay,navigation,testimonialsPage,headerEnable,backgroundColorEnable,appKey,embeddedWidgetLogic,embeddedWidgetReviews,embeddedWidgetHeaderText,embeddedWidgetWidth,embeddedWidgetHeaderBackgroundColor,embeddedWidgetBodyBackgroundTransparent,embeddedWidgetHeaderFontSize,embeddedWidgetFontColor',
    default_value: 'carousel',
  },
  {
    name: 'mode',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-mode',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: 'topRated',
    options: [
      {
        key: 'topRated',
        value: 'Top Rated',
      },
      {
        key: 'mostRecent',
        value: 'Most Recent',
      },
    ],
  },
  {
    name: 'type',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-type',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: 'site',
    options: [
      {
        key: 'site',
        value: 'Site Reviews',
      },
      {
        key: 'both',
        value: 'Site & Product Reviews',
      },
      {
        key: 'product',
        value: 'Product Reviews - All Products',
      },
      {
        key: 'per_product',
        value: 'Product Reviews - Product Page',
      },
    ],
  },
  {
    name: 'count',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-count',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '9',
  },
  {
    name: 'showBottomLine',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-show-bottomline',
    targetSelector: '.module  .yotpo-reviews-carousel',
    default_value: '1',
  },
  {
    name: 'autoplay',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-autoplay-enabled',
    targetSelector: '.module  .yotpo-reviews-carousel',
    default_value: '9',
    links: 'speed',
  },
  {
    name: 'speed',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-autoplay-speed',
    targetSelector: '.module  .yotpo-reviews-carousel',
    default_value: '3000',
  },
  {
    name: 'navigation',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-show-navigation',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '1',
  },
  {
    name: 'testimonialsPage',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-testimonials-page-enabled',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '0',
    links: 'testimonialsPageText,testimonialsPageURL',
  },
  {
    name: 'testimonialsPageText',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-testimonials-page-text',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: 'See All Review',
  },
  {
    name: 'testimonialsPageURL',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-testimonials-page-link',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '',
  },
  // embedded widget
  {
    name: 'embeddedWidgetLogic',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-product-id',
    targetSelector: '.module>.embedded-widget',
    default_value: 'top_rated_products',
    options: [
      {
        key: 'top_rated_products',
        value: 'Top Products',
      },
      {
        key: 'yotpo_global_reviews',
        value: 'Recent Reviews',
      },
    ],
    links: 'embeddedWidgetLayoutTopRated,embeddedWidgetLayoutRecentReviews',
  },
  {
    name: 'embeddedWidgetLayoutTopRated',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-layout',
    targetSelector: '.module>.embedded-widget',
    default_value: 'basic',
    options: [
      {
        key: 'basic',
        value: 'Basic Layout',
      },
      {
        key: 'pictures',
        value: 'Photos Layout',
      },
    ],
  },
  {
    name: 'embeddedWidgetLayoutRecentReviews',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-layout',
    targetSelector: '.module>.embedded-widget',
    default_value: 'basic',
    options: [
      {
        key: 'basic',
        value: 'Basic Layout',
      },
      {
        key: 'pictures',
        value: 'Photos Layout',
      },
      {
        key: 'reviews',
        value: 'Reviews Layout',
      },
    ],
  },
  {
    name: 'embeddedWidgetReviews',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-reviews',
    targetSelector: '.module>.embedded-widget',
    default_value: '5',
  },
  {
    name: 'embeddedWidgetHeaderText',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-header-text',
    targetSelector: '.module>.embedded-widget',
    default_value: 'Top Rated Products',
  },
  // advanced options
  {
    name: 'headerEnable',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-header-customisation-enabled',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '0',
    links: 'headerText,headerTextColor,headerTextSize,headerTextAlignment',
  },
  {
    name: 'headerText',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-header-customisation-text',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '',
  },
  {
    name: 'headerTextColor',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-header-customisation-color',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '#56575f',
  },
  {
    name: 'headerTextSize',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-header-customisation-font-size',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '18',
  },
  {
    name: 'headerTextAlignment',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-header-customisation-alignment',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: 'left',
    // "dataValue": "left,center",
    // "columns": "Left,Center",
  },
  {
    name: 'backgroundColorEnable',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-background-color-enabled',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '0',
    links: 'backgroundColor',
  },
  {
    name: 'backgroundColor',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-background-color',
    targetSelector: '.module>.yotpo-reviews-carousel',
    default_value: '#ffffff',
  },
  {
    name: 'embeddedWidgetWidth',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-width',
    targetSelector: '.module>.embedded-widget',
    default_value: '100',
  },
  {
    name: 'embeddedWidgetHeaderBackgroundColor',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-header-background-color',
    targetSelector: '.module>.embedded-widget',
    default_value: '#919191',
  },
  {
    name: 'embeddedWidgetBodyBackgroundTransparent',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-transparency',
    targetSelector: '.module>.embedded-widget',
    default_value: '0',
    links: 'embeddedWidgetBodyBackgroundColor',
  },
  {
    name: 'embeddedWidgetBodyBackgroundColor',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-body-background-color',
    targetSelector: '.module>.embedded-widget',
    default_value: '#ffffff',
  },
  {
    name: 'embeddedWidgetHeaderFontSize',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-font-size',
    targetSelector: '.module>.embedded-widget',
    default_value: '18',
  },
  {
    name: 'embeddedWidgetFontColor',
    type: 'html:attr',
    refreshType: 'all',
    property: 'data-font-color',
    targetSelector: '.module>.embedded-widget',
    default_value: '#ffffff',
  },

  {
    type: 'html:attr',
    name: 'appKey',
    property: 'data-appkey',
    targetSelector: '.module>.embedded-widget',
    visible: 'field-hide-all',
    default_value: '',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * GpYotpoCustomPages Atom Module
 */
export class GpYotpoCustomPages extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Yotpo - Custom Pages';
  }
  /**
   * override getSlug từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'yotpo-featured';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
